import Success from '../../../../assets/images/success.svg';
import { Icon } from '@gs/fe-storybook-gasco';
import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import './FinalStepContent.css';

const FinalStepContent: React.FC<{
  status: 'success' | 'error' | null;
  responseCode: string;
  responseHash: string;
}> = ({ status, responseCode, responseHash }) => {
  const navigate = useNavigate();

  const logOut = useCallback(() => {
    localStorage.removeItem('accessToken');
    navigate('/');
  }, [navigate]);

  useEffect(() => {
    if (status === 'success') {
      const timer = setTimeout(() => {
        logOut();
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [status, logOut]);

  return (
    <>
      <div className="status">
        {status === "success" && (
          <div className="success" id="page-success" data-page-id="exito">
            <Icon className="success-icon" name="check-circle" />
            <p className="rut-success">
              Tu RUT ha sido modificado exitosamente
            </p>
            <br />
            <p className="rut-title">¡Tus respuestas fueron correctas! </p>
            <p className="rut-second-title">
              Por lo tanto tu operación ha sido realizada exitosamente
            </p>
            <br />
            <div className="rut-content">
              <p className="rut-paragraph">
                En unos segundos te redireccionaremos al sitio para continuar
                con tus operaciones.
              </p>
              <img
                className="rut-image"
                src={Success}
                alt="RUT Modificado Exitosamente"
              />
            </div>
            <br />
            <div className="confirm-button">
              <button onClick={logOut} className="success-button" id="exito_redireccionarse">
                Redireccionarse ahora
              </button>
            </div>
            <br />
          </div>
        )}

        {status === "error" && (
          <div className="error-step-container" id="page-error" data-page-id="error">
            <Icon className="error-icon" name="x-circle" />
            <p className="rut-error">
              No hemos podidos modificar tu información
            </p>
            <br />
            <p className="rut-title">
              Algunos de los datos ingresados son incorrectos.{" "}
            </p>
            <p className="rut-second-title">
              Te recomendamos volver a intentarlo en 24 horas.
            </p>
            <br />

            <br />

            <div className="fail-button">
              <div className="error-response">
                {responseCode}
                <br />
                {responseHash}
              </div>
              <button onClick={logOut} className="error-button" id="error_cerrar">
                {" "}
                Cerrar
              </button>
            </div>
            <br />
          </div>
        )}
      </div>
    </>
  );
};

export default FinalStepContent;
